module.exports = __webpack_public_path__ + "img/carousel-servicios-6.fe2fdd6d.jpg";